import React from 'react';
import Header from "../components/header/Header";
import SkeletonHomeSlider from "./topGallery/SkeletonHomeSlider";
import SkeletonPromoBanners from "./banner/SkeletonPromoBanners";
import SkeletonPromoProducts from "./skeletonPromoProducts/SkeletonPromoProducts";
import Footer from "../components/footer/Footer";
import SkeletonNewProducts from "./skeletonNewProducts/SkeletonNewProducts";
import SkeletonProductSlider from "./skeletonProductSlider/SkeletonProductSlider";
import SkeletonNumberedProducts from "./skeletonNumberedProducts/SkeletonNumberedProducts";
import SkeletonBrands from "./skeletonBrands/SkeletonBrands";
import SkeletonBanners_b from "./banner/SkeletonBanners_b";
import SkeletonBanners_a from "./banner/SkeletonBanners_a";
import SkeletonBundles from "./skeletonBundles/SkeletonBundles";
import SkeletonLatestNews from "./skeletonLatestNews/SkeletonLatestNews";
import SkeletonCtaBlue from "./skeletonCtaBlue/SkeletonCtaBlue";
import SkeletonTopBanner from "./skeletonResponsive/SkeletonTopBanner";
import SkeletonGallery from "./skeletonResponsive/SkeletonGallery";

const HomePageSkeleton = () => {
    return (
        <div className="home-page-skeleton">
            <Header/>
            <div className="skeleton-home-page-desktop d-none d-lg-block">
                <SkeletonHomeSlider/>
                <SkeletonPromoBanners/>
                <SkeletonPromoProducts/>
                <SkeletonNewProducts/>
                <SkeletonProductSlider/>
                <SkeletonBanners_a/>
                <SkeletonNumberedProducts/>
                <SkeletonBrands/>
                <SkeletonProductSlider/>
                <SkeletonBanners_b/>
                <SkeletonBundles/>
                <SkeletonLatestNews/>
                <SkeletonCtaBlue/>
            </div>
            <div className="skeleton-home-page-mobile d-block d-lg-none">
                <SkeletonTopBanner/>
                <SkeletonGallery/>
            </div>
            <Footer/>
        </div>
    );
};

export default HomePageSkeleton;
